import { createSelector } from "reselect";
import _ from "lodash";

import { checkIsExternalUser } from "../helpers/Authorization/authorizationHelpers";

const advancedSearchResultsSelector = state => state.advancedSearch.results;
const billsOfLadingSelector = state => state.billsOfLading.billsOfLadingById;
const customerSelector = (state, id) => state.customer.customersById[id];
const customersSelector = state => state.customer.customersById;
const loadSelector = (state, id) => state.loads.loadsById[id];
const loadsSelector = state => state.loads.loadsById;
const millOrdersSelector = state => state.millOrder.millOrdersById;
const notificationsSelector = state => state.notifications.notificationsById;
const orderedProductsSelector = state => state.orderedProducts.orderedProductsById;
const pendingActionsSelector = (state, actionIds) => _.intersection(state.app.pendingActions, [...actionIds]).length > 0;
const prePlanningsSelector = state => state.prePlanning.prePlanningsById;
const purchaseOrderSelector = (state, id) => state.purchaseOrder.purchaseOrdersById[id];
const purchaseOrdersSelector = state => state.purchaseOrder.purchaseOrdersById;
const unitOfMeasurementSelector = state => state.unitOfMeasurements.unitOfMeasurementsById;

// App
export const getUnitOfMeasurementsSelector = createSelector(unitOfMeasurementSelector, uomId => Object.values(uomId));
export const getGroupedByTypeUnitOfMeasurementsSelector = createSelector(unitOfMeasurementSelector, uomId => _.groupBy(Object.values(uomId), "type"));

// Advanced Search
export const getAdvancedSearchResultsSelector = createSelector(advancedSearchResultsSelector, resultsById => Object.values(resultsById));

// Bills Of Lading
export const getBillsOfLadingSelector = createSelector(billsOfLadingSelector, billsOfLadingById => Object.values(billsOfLadingById));
export const getFirstBillOfLadingSelector = createSelector(billsOfLadingSelector, billsOfLadingById => _.first(Object.values(billsOfLadingById)));

// Customers
export const getCustomerSelector = createSelector(
  customerSelector,
  customersSelector,
  (customer, customers) => (checkIsExternalUser() ? _.first(Object.values(customers)) : customer)
);

export const getCustomersSelector = createSelector(customersSelector, customersById =>
  Object.values(customersById).map(customer => {
    const { customerSelection = [] } = customer;

    return {
      ...customer,
      customerSelection: customerSelection.map(selection => ({
        ...selection,
        customerTypeKey: customer.customerType,
        customerTypeValue: customer.customerTypeValue
      }))
    };
  })
);

export const getCustomerSelectionsSelector = createSelector(customersSelector, customersById => {
  return _.flatten(
    Object.values(customersById).map(customer => {
      const { customerSelection = [] } = customer;
      return customerSelection.map(selection => ({
        ...selection,
        customerTypeKey: customer.customerType,
        customerTypeValue: customer.customerTypeValue
      }));
    })
  );
});

// Loads
export const getLoadSelector = createSelector(loadSelector, load => load);
export const getLoadsSelector = createSelector(loadsSelector, loadsById => Object.values(loadsById));

// Loading
export const getIsLoadingSelector = createSelector(pendingActionsSelector, isLoading => isLoading);

// Mill Orders
export const getMillOrdersSelector = createSelector(millOrdersSelector, millOrdersById => Object.values(millOrdersById));
export const getFirstMillOrderSelector = createSelector(millOrdersSelector, millsOrderById => _.first(Object.values(millsOrderById)));

// Notifications
export const getNotificationsSelector = createSelector(notificationsSelector, id =>
  _.orderBy(Object.values(id), notification => _.get(notification, "created"), "desc")
);

// Ordered products
export const getOrderedProductsSelector = createSelector(orderedProductsSelector, orderedProductsById => Object.values(orderedProductsById));

// Pre Planning
export const getPrePlanningSelector = createSelector(prePlanningsSelector, prePlanningsById => Object.values(prePlanningsById));

// Purchase Orders
export const getPurchaseOrderSelector = createSelector(purchaseOrderSelector, purchaseOrder => purchaseOrder);
export const getPurchaseOrdersSelector = createSelector(purchaseOrdersSelector, purchaseOrdersById => Object.values(purchaseOrdersById));



// WEBPACK FOOTER //
// ./src/selectors/selectors.js